// Drop Zone v2 — detection engine public surface (spec #761, Phase 1).
//
// Single source of truth for "what is this thing the user dropped?", shared by
// `cloudgrid plug` (CLI) and the Drop Zone v2 surface (browser + server).
//
// Node callers: `detectArtifact` (supports both `entries` and `folder` sources).
// Browser/isomorphic callers: import `detectFromEntries` (filename-only, no fs)
// — re-exported here and defined in `core.ts`.

export * from './types.js';
// Layer 1 (filename-only) is browser-safe — re-exported straight from the pure
// core so importing it does not pull `node:fs` in. Layer 2 (`detectArtifact`,
// which can read a folder on disk) comes from detect.js and is node-only; a
// bundler tree-shakes it away when a browser caller only uses detectFromEntries.
export { detectFromEntries } from './core.js';
export { detectArtifact } from './detect.js';

// BL592 knowledge base — the signature registry + its pure matcher. Browser-safe
// (no fs); the node-only snapshot reader lives in folder-scan.ts.
export {
  STACK_SIGNATURES,
  findMatchingSignatures,
} from './knowledge-base.js';
export type {
  StackSignature,
  StackPitfall,
  RepoSnapshot,
  PackageJsonShape,
} from './knowledge-base.js';

// Heuristic primitives the CLI reuses so the two surfaces never drift.
export {
  INSPIRATION_SOURCE_TYPES,
  INSPIRATION_EXTENSIONS,
  extOf,
  extToSubtype,
} from './heuristics/inspiration.js';
export { deriveSlug, isGenericName } from './heuristics/slug.js';
export { deriveName } from './heuristics/name.js';
export { packageJsonHasNext } from './heuristics/app.js';
export { isNoisePath, isNoiseSegment, filterNoise } from './noise.js';
